import { Alert, Image } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import NoData from '../../shared/noDataComponent';
import Loader from '../../shared/loader.component';
import apiCalls from 'src/api/apiCalls';
import { DownloadButton } from './service';
const badge = { active: "bg-green", pending: "bg-pending", failed: "bg-red",
   cancel: "bg-red", freeze: "bg-freeze", consume: "bg-consume", fail: "bg-red", 
   kycrejected: "bg-red", kycpending: "bg-pending", cancelled: "bg-red", rejected: "bg-red",
    success: "bg-green", unFreeze: "bg-freeze", suspended: "bg-red", submitted: "bg-submitted" }

    const KYBImageCard = ({ title, details, renderKYCImage }) => (
      <div className=''>
        <h2 className="text-titleColor font-semibold text-2xl mb-3 ">{title}</h2>
        {details?.length > 0 ? (
          <div className="grid md:grid-cols-2 gap-6">
            {details?.map((doc, index) =>
              renderKYCImage(doc?.idType || `Document ${index + 1}`, doc?.image)
            )}
          </div>
        ) : (
          <NoData />
        )}
      </div>
    );
    
const KycInfo = () => {
  const [kycDetails, setKycDetails] = useState(null);
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  useEffect(() => {
    fetchKycData();
  }, []);
  const fetchKycData = async () => {
    setLoader(true);
    setErrorMsg(null)
    try {
      const detailsResponse = await apiCalls.kycDetails()
      if (detailsResponse.ok) {
        setKycDetails(detailsResponse.data);
        return
      } else {
        handleError(detailsResponse);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };
  const handleError = (error) => {
    const message = apiCalls.isErrorDispaly(error);
    setErrorMsg(message);
  };
  const handleDownload = useCallback((fileUrl) => () => {
    if (fileUrl) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileUrl.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("Download URL is not available.");
    }
  }, []);

  const onLoadImage = useCallback((imageUrl) => (e) => {
    e.target.src = imageUrl;
    e.target.style.filter = 'none';
  }, [])

  const downloadButton = useCallback((imageUrl) =>{
    return <DownloadButton imageUrl={imageUrl} handleDownload={handleDownload} />
  }, [handleDownload])
  const renderKYCImage = useCallback((label, imageUrl) => {
    if (!imageUrl) return null;
  
    const handleImageLoad = onLoadImage(imageUrl);
    const renderDownloadButton = downloadButton(imageUrl);
  
    return (
      <div className=''>
        <div className="">
          <p className="mb-0.5 text-labelGrey">{label}</p>
          <div className="relative kyc-preview group bg-overlay">
            <Image
              src={`${imageUrl}?w=200&blur=20`}
              className="mb-1 mx-auto rounded-5 !object-cover"
              alt={label}
              style={{ width: '100%', height: '184px' }}
              onLoad={handleImageLoad}
              preview={{
                toolbarRender: () => renderDownloadButton,
              }}
            />
          </div>
        </div>
      </div>
    );
  }, [onLoadImage, downloadButton]);


  return (
    <div className='loader-static'>
      {loader ? <><div className="h-[80vh] flex justify-center items-center"><Loader className="" /></div></> : <>
        {errorMsg && <div className='mb-4'>
          <Alert variant="danger" className='alert-flex' description={errorMsg}
            showIcon closable>
            <p style={{ color: 'red', margin: 10 }}><span className="icon error-alert me-2"></span>{errorMsg}</p>
          </Alert>
        </div>}
        {kycDetails && <>
          <div className='grid md:grid-cols-2 gap-4'>
           {kycDetails?.companyName &&<div>
              <p className='summary-label'> Company Name</p>
              <p className='summary-value'>{kycDetails?.companyName || ""}</p>
            </div>}
           {kycDetails?.country && <div>
              <p className='summary-label'>Country</p>
              <p className='summary-value'>{kycDetails?.country || ""}</p>
            </div>}
           {kycDetails?.registrationNumber &&<div>
              <p className='summary-label'>Registration Number</p>
              <p className='summary-value'>{kycDetails?.registrationNumber || ""}</p>
            </div>}
           {kycDetails?.locationOfRegistration &&<div>
              <p className='summary-label'>Location Of Registration</p>
              <p className='summary-value'>{kycDetails?.locationOfRegistration || ""}</p>
            </div>}
           {kycDetails?.legalAddress && <div>
              <p className='summary-label'>Legal Address</p>
              <p className='summary-value'>{kycDetails?.legalAddress || ""}</p>
            </div>}
           {kycDetails?.postalAddress && <div>
              <p className='summary-label'>Postal Address</p>
              <p className='summary-value'>{kycDetails?.postalAddress || ""}</p>
            </div>}
            {kycDetails?.taxId && <div>
              <p className='summary-label'>Tax ID</p>
              <p className='summary-value'>{kycDetails?.taxId || ""}</p>
            </div>}
            {kycDetails?.website && <div className='info-border-remove'>
              <p className='summary-label'>Website</p>
              <p className='summary-value word-breall'>{kycDetails?.website || ""}</p>
            </div>}
            {kycDetails?.dateOfRegistration &&<div>
              <p className='summary-label'>Date Of Registration</p>
              <p className='summary-value word-breall'>{kycDetails?.dateOfRegistration ? moment(kycDetails?.dateOfRegistration).format('DD/MM/YYYY') : ""}</p>
            </div>}
            {kycDetails?.companyTelephone &&<div>
              <p className='summary-label'>Company Telephone</p>
              <p className='summary-value word-breall'>{kycDetails?.companyTelephone || ""}</p>
            </div>}
            {kycDetails?.typeOfEntity &&<div>
              <p className='summary-label'>Type Of Entity</p>
              <p className='summary-value word-breall'>{kycDetails?.typeOfEntity || ""}</p>
            </div>}
            {kycDetails?.companyStatus && <div>
              <p className='summary-label'>Company Status</p>
              <p className='summary-value'><span className={`status-badge ${badge[kycDetails?.companyStatus?.toLowerCase()]}`}>{kycDetails?.companyStatus || ""}</span></p>
            </div>}
            {kycDetails?.industryCode &&<div>
              <p className='summary-label'>Industry Code</p>
              <p className='summary-value word-breall'>{kycDetails?.industryCode || ""}</p>
            </div>}
            {kycDetails?.industryDescription && <div>
              <p className='summary-label'>Industry Description</p>
              <p className='summary-value word-breall'>{kycDetails?.industryDescription || ""}</p>
            </div>}
            {kycDetails?.licenseNumber &&<div>
              <p className='summary-label'>License Number</p>
              <p className='summary-value word-breall'>{kycDetails?.licenseNumber || ""}</p>
            </div>}
            {kycDetails?.dateOfIssue &&<div>
              <p className='summary-label'>Date Of Issue</p>
              <p className='summary-value'>{kycDetails?.dateOfIssue ? moment(kycDetails?.dateOfIssue).format('DD/MM/YYYY') : ""}</p>
            </div>}
            {kycDetails?.licenseValidUpto && <div>
              <p className='summary-label'>License Valid Upto</p>
              <p className='summary-value'>{kycDetails?.licenseValidUpto ? moment(kycDetails?.licenseValidUpto).format('DD/MM/YYYY') : ""}</p>
            </div>}
            {kycDetails?.proofOfAddress &&<div>
              <p className='summary-label'>Proof Of Address</p>
              <p className='summary-value word-breall'>{kycDetails?.proofOfAddress || ""}</p>
            </div>}
          </div>
          <div className='mt-4'>
            {kycDetails?.uboDetails?.[0]?.identityDetails && <KYBImageCard title="Identification Documents" details={kycDetails?.uboDetails?.[0]?.identityDetails} renderKYCImage={renderKYCImage} />}
            {!loader && (!kycDetails?.uboDetails?.[0]?.identityDetails) && <NoData />}
          </div></>}
      </>}</div>)
}
export default KycInfo